const YoutubeIframes = () => {

    const allIframes = document.querySelectorAll('.entry-content.wd-entry-content iframe');

    if(allIframes) {
        for(var i = 0; i < allIframes.length; i++) {
            if(!allIframes[i].parentNode.classList.contains('movie-wrapper')) {
                allIframes[i].parentNode.classList.add('movie-wrapper');
            }
        }
    }

}

export default YoutubeIframes;